import { indexItems } from '@/mocks/chiguaData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100">
            <i className="ri-grid-line text-xl text-secondary-700"></i>
          </div>
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
              内容分类
            </h2>
            <p className="text-sm text-foreground-500 mt-0.5">按分类浏览你感兴趣的吃瓜内容</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="group rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 p-5 transition-colors cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-colors mb-4">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-1.5">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3">
                {item.description}
              </p>
              <span className="text-xs text-primary-600 font-medium">
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}